module.exports = __webpack_public_path__ + "static/img/nochart.9327495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nochart.png
// module id = WYqT
// module chunks = 1